import { isDefined } from '@aloft/toolkit-shared';
import { colors } from '@aloft/toolkit-sui';
import { StyleSheet, View } from '@react-pdf/renderer';

import { Text } from '../../../components/PdfExportV2/Text/Text.tsx';

const styles = StyleSheet.create({
  listItemWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  listItemDotSmall: {
    height: '3px',
    width: '3px',
    top: '6px',
    borderRadius: '1.5px',
    backgroundColor: colors.textSecondary,
  },
  listItemDotMedium: {
    height: '4px',
    width: '4px',
    top: '5px',
    borderRadius: '2px',
    backgroundColor: colors.textSecondary,
  },
});

export const ExportListItem = ({
  text,
  size = 'sm',
  index,
}: {
  text: string;
  size?: 'sm' | 'md';
  index?: number;
}) => (
  <View style={[styles.listItemWrapper, { gap: size === 'sm' ? '3px' : '5px' }]}>
    {isDefined(index) ? (
      <Text variant={size === 'sm' ? 'body2' : 'body1'}>{`${index.toString()}.`}</Text>
    ) : (
      <View style={size === 'sm' ? styles.listItemDotSmall : styles.listItemDotMedium} />
    )}
    <Text variant={size === 'sm' ? 'body2' : 'body1'} flex={1}>
      {text}
    </Text>
  </View>
);
